<template>
  <div class="container pending">
    <div class="pending-wrapper">
      <div class="container pending-text">{{ title }}</div>
      <div class="row" v-if="!loading" :key="changeView">
        <div :key="index" v-for="(job, index) in jobs" class="col-12 job">
          <div v-if="newUsers">
            <user-synopsis
              v-bind:job="job"
              v-bind:plans="plans"
              v-bind:index="index"
              v-on:approve-user="changeJobStatus"
              v-on:delete-user="deleteCompany"
            ></user-synopsis>
          </div>
          
          <div v-else-if="allUsers" :key="changeView" >
            <all-user-synopsis
              v-bind:job="job"
              v-bind:plans="plans"
              v-bind:index="index"
              v-bind:registered="registered"
              v-on:delete-user="deleteCompany"
            ></all-user-synopsis>
          </div>
          <div v-else>
            <expired-synopsis
              v-bind:job="job"
              v-bind:plans="plans"
              v-bind:index="index"
              v-bind:requested="requested"
              v-on:approve-user="updateJobStatus"
            ></expired-synopsis>
          </div>
        </div>
      </div>
      <div v-if="loading" class="row no-result no-padding">
        <loader></loader>
      </div>
      <div v-if="noData" class="row no-result no-padding">
        <div class="mx-auto my-auto">
          <img src="@/assets/notFound.svg" />
          <div class="no-result-color"><b>No Pending Job</b></div>
        </div>
      </div>
    </div>
    <v-snackbar :color="bgColor" :timeout="timeOut" top v-model="snackbar">
      <div style="text-align: center; width: 100%">
        <span style="padding-right:10px"
          ><v-icon color="#fff">{{ snackIcon }}</v-icon></span
        >{{ snackMessage }}
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import UserSynopsis from "./new-user-synopsis";
import AllUserSynopsis from "./all-user-synopsis";
import ExpiredSynopsis from "./expired-users-synopsis";
import Loader from "../../global-components/loader"
import {
  CHANGE_USER_STATUS, DELETE_COMPANY,
  GET_USERS_ADMIN,
  UPDATE_USER_STATUS
} from "../../../Api/admin_api";
export default {
  name: "pending-jobs",
  components: {
    UserSynopsis,
    ExpiredSynopsis,
    AllUserSynopsis,
    Loader
  },
  data: function() {
    return {
      title: null,
      newUsers: null,
      jobs: [],
      plans: [],
      noData: false,
      bgColor: "#454545",
      timeOut: 2000,
      snackbar: false,
      snackIcon: "",
      snackMessage: "",
      ripple: false,
      changeView: 0,
      loading: true,
      reqObject: null,
      requested: null,
      allUsers: null,
      registered: false
    };
  },
  methods: {
    resetAll() {
      const self = this;
      self.jobs = [];
      self.plans = [];
      self.noData = false;
      self.changeView = 0;
    },
    updateJobStatus(plan_id, company_id, index, discount, payment_status) {
      const self = this;
      let params = {
        company_id: company_id,
        plan_id: plan_id
      };
      if (discount) params.discount = parseInt(discount);
      if (payment_status) params.payment_status = payment_status;
      self.loading = true;
      UPDATE_USER_STATUS(params)
        .then(function(response) {
          self.loading = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
          self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
          self.jobs.splice(index, 1);
          self.changeView++;
        })
        .catch(function(err) {
          self.loading = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.message;
        });
    },
    changeJobStatus(company_id, index, override) {
      const self = this;
      let params = {
        company_id: company_id
      };
      if(override) {
          params.override = true;
      }
      self.loading = true;
      CHANGE_USER_STATUS(params)
        .then(function(response) {
          self.loading = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
          self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
          self.snackMessage = response.message;
          self.jobs.splice(index, 1);
          self.changeView++;
        })
        .catch(function(err) {
          self.loading = false;
          self.snackbar = true;
          self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
          self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
          self.snackMessage = err.response.data.title;
        });
    },
    deleteCompany(company_id, index, obj_type) {
      const self = this;
      let params = {
        company_id: company_id
      };
      self.loading = true;
      DELETE_COMPANY(params).then((response) => {
        self.loading = false;
        self.snackbar = true;
        self.snackIcon = self.$constants.SNACKBAR_ICON.SUCCESS;
        self.bgColor = self.$constants.SNACKBAR_COLOR.SUCCESS;
        self.snackMessage = response.message;
        self.jobs.splice(index, 1);
        self.changeView++;
        self.reqObject = {
          obj_type: obj_type
        };
        console.log(self.reqObject)
        self.getPendingJobs(self.reqObject);
      })
      .catch(function(err) {
        self.loading = false;
        self.snackbar = true;
        self.snackIcon = self.$constants.SNACKBAR_ICON.ERROR;
        self.bgColor = self.$constants.SNACKBAR_COLOR.ERROR;
        self.snackMessage = err.response.data.title;
      });
    },
    getPendingJobs: function(subs, featured) {
      const self = this;
      self.resetAll();
      self.loading = true;
      GET_USERS_ADMIN(subs, featured)
        .then(function(data) {
          self.loading = false;
          self.jobs = data.companies;
          self.plans = data.plans;
          if (self.jobs.length === 0) {
            self.noData = true;
          }
        })
        .catch(function() {
          self.loading = false;
          self.noData = true;
        });
    }
  },
  watch: {
    "$route.query.q"(newQ, oldQ) {
      if (newQ !== oldQ) {
        if (newQ === "expired") {
          this.title = "Expired companies";
          this.newUsers = false;
          this.requested = false;
          this.allUsers = false;
          this.registered = false;
          this.reqObject = {
            f: 0
          };
          this.getPendingJobs(this.reqObject, true);
        } else if (newQ === "registered") {
          this.title = "All Registered Companies";
          this.newUsers = false;
          this.allUsers = true;
          this.requested = false;
          this.registered = true;
          this.reqObject = {
            f: 2
          };
          this.getPendingJobs(this.reqObject, true);
        } else if (newQ === "requested") {
          this.title = "Requested for new plan";
          this.newUsers = false;
          this.allUsers = false;
          this.requested = true;
          this.registered = false;
          this.reqObject = {
            f: 1
          };
          this.getPendingJobs(this.reqObject, true);
        } else if (newQ === "duplicate") {
          this.title = "Duplicate Companies (By Name)";
          this.newUsers = false;
          this.allUsers = true;
          this.requested = false;
          this.registered = false;
          this.reqObject = {
            obj_type: 48
          };
          this.getPendingJobs(this.reqObject);
        } else if (newQ === "duplicate-mail") {
          this.title = "Duplicate Companies (By Email)";
          this.newUsers = false;
          this.allUsers = true;
          this.requested = false;
          this.registered = false;
          this.reqObject = {
            obj_type: 54
          };
          this.getPendingJobs(this.reqObject);
        } else {
          this.title = "Pending Companies";
          this.newUsers = true;
          this.allUsers = false;
          this.registered = false;
          this.reqObject = {
            obj_type: 35
          };
          this.getPendingJobs(this.reqObject);
        }
      }
    }
  },
  mounted() {
    if (this.$route.query.q === "expired") {
      this.title = "Expired companies";
      this.newUsers = false;
      this.allUsers = false;
      this.requested = false;
      this.reqObject = {
        f: 0
      };
      this.getPendingJobs(this.reqObject, true);
    } else if (this.$route.query.q === "requested") {
      this.title = "Requested for new plan";
      this.newUsers = false;
      this.allUsers = false;
      this.requested = true;
      this.reqObject = {
        f: 1
      };
      this.getPendingJobs(this.reqObject, true);
    } else if (this.$route.query.q === "registered") {
      this.title = "All Registered Companies";
      this.allUsers = true;
      this.newUsers = false;
      this.requested = false;
      this.registered=true;
      this.reqObject = {
        f: 2
      };
      this.getPendingJobs(this.reqObject, true);
    } else if (this.$route.query.q === "duplicate") {
      this.title = "Duplicate Companies";
      this.allUsers = true;
      this.newUsers = false;
      this.requested = false;
      this.reqObject = {
        obj_type: 48
      };
      this.getPendingJobs(this.reqObject);
    } else if (this.$route.query.q === "duplicate-mail") {
        this.title = "Duplicate Companies (By Email)";
        this.newUsers = false;
        this.allUsers = true;
        this.requested = false;
        this.registered = false;
        this.reqObject = {
            obj_type: 54
        };
        this.getPendingJobs(this.reqObject);
    } else {
      this.title = "New Companies";
      this.newUsers = true;
      this.allUsers = false;
      this.reqObject = {
        obj_type: 35
      };
      this.getPendingJobs(this.reqObject);
    }
  }
};
</script>

<style scoped>
.pending {
  margin: 70px 0 0 0;
  height: 80vh;
  overflow-y: auto;
}
.pending-wrapper {
  /*margin-top: 7.5rem;*/
}
.pending-text {
  position: absolute;
  top: 70px;
  padding: 20px;
  background-color: var(--synop-select-color);
  width: 100%;
  height: 70px;
  z-index: 50;
  text-align: left;
  font-size: 24px;
  color: #050505;
}
.job {
  margin: 1rem 0 !important;
  border: 1px solid #e6e6e6;
  border-radius: 0.4rem;
  width: 100%;
  padding: 0;
}
.but {
  text-align: right;
  padding: 30px;
}
.no-result {
  margin-top: 25px !important;
  height: 700px;
}
.no-result-color {
  color: #bbbec1;
}
</style>
